import { useState, useEffect, useRef } from "react";
import styles from "./Overview.module.css";
import { Card, Col, Row } from "antd";
import Arrow from "../../assets/img/material-symbols_arrow-insert.png";
import { getCookie } from "../../utils/cookies";
import { getCurrentNotice, getUserImages } from "../../services/common.service";
import ScmIcon from "../../assets/img/scm-icon.png";
import ScmGrayIcon from "../../assets/img/scm_gray_icon.png";
import RotaIcon from "../../assets/img/rota-icon.png";
import RotaGrayIcon from "../../assets/img/rota_gray_icon.png";
import AcademyIcon from "../../assets/img/academy-icon.png";
import AcademyGrayIcon from "../../assets/img/academy_gray_icon.png";
import KbIcon from "../../assets/img/kb-icon.png";
import CaGrayIcon from "../../assets/img/ca_gray_icon.png";
import CaIcon from "../../assets/img/ca-icon.png";
import B4cGrayIcon from "../../assets/img/b4c_gray_icon.png";
import B4cIcon from "../../assets/img/b4c-icon.png";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Apps } from "../../utils/enum";
import { getUserCompaniesByUID } from "../../services/auth.service";
import DefaultCompanyLogo from "../../assets/img/Logo-Black-100px.png";
import LeftArrow from "../../assets/img/left-arrow.png";
import RightArrow from "../../assets/img/right-arrow.png";
import CareHiresLogo from '../../assets/img/CH_New_Logo_updated.png';

function Overview() {
  const accessToken = getCookie("firebase_token") as string;
  const chUserDataCookie = localStorage.getItem("ch_user_data");
  const userData = JSON.parse(chUserDataCookie as string);
  const [currentUser, setCurrentUser] = useState<any>(userData);
  const userCompanies = JSON.parse(localStorage.getItem("companies") as string);
  const [userApps, setUserApps] = useState<any>([]);
  const [noticeData, setNoticeData] = useState<any>([]);
  const [chBlogData, setChBlogData] = useState<any>([]);
  const [myApps, setMyApps] = useState<any>([]);
  const [otherApps, setOtherApps] = useState<any>([]);
  const myAppsRef = useRef(null);
  const otherAppsRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isOtherOverflowing, setIsOtherOverflowing] = useState(false);

  const isAgencyUser = currentUser?.userGroup === 'Agency';

  const checkOverflow = () => {
    const myAppsContainer: any = myAppsRef.current;
    const otherAppsContainer: any = otherAppsRef.current;
    if (myAppsContainer) {
      setIsOverflowing(myAppsContainer.scrollWidth > myAppsContainer.clientWidth);
    }
    if (otherAppsContainer) {
      setIsOtherOverflowing(otherAppsContainer.scrollWidth > otherAppsContainer.clientWidth);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);

  const scroll = (direction: any, ref: any) => {
    const container = ref.current;
    const scrollAmount = 200; 
    if (container) {
      container.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
    }
  };
  const appComponents = [
    {
      appId: Apps.SCM,
      myAppComponent: (
        <Card className={styles.appCard} style={{ width: '500px', marginRight: '10px', minHeight: '190px' }} onClick={() => goToPlatform(import.meta.env.VITE_SCM_DASHBOARD_URL as string)}>
          <img
            className="login-title"
            src={CareHiresLogo}
            alt="CareHires Logo"
          />
          <h4>
          {!isAgencyUser && (
            <span style={{ color: "#1D4ED8", fontWeight: 600 }}>Supply Chain Management</span> 
          )}
          {isAgencyUser && (
            <span style={{ color: "#1D4ED8", fontWeight: 600 }}>Agency Accelerator</span> 
          )}
          </h4>
          <div className={styles.lineSeparator}></div>
          <div className={styles.contentWrapper}>
            <img src={ScmIcon} alt="Care Hires" />
            <p>
              Streamline recruitment by seamlessly connecting care providers,
              agencies, and workers
            </p>
          </div>
        </Card>
      ),
      otherAppComponent: (
        <Card className={styles.interestedCard}>
          <h3 className={styles.cardTitle}>
            <span className={styles.capitalText}>Care</span>
            <span className={styles.advanceText}> Hires</span>
          </h3>
          <hr />
          <div className={styles.lineSeparator}></div>
          <p className={styles.cardDescription}>
            <img src={ScmGrayIcon} alt="arrow" className={styles.arrowIcon} />
            Streamline recruitment by seamlessly connecting care providers,
            agencies, and workers.
          </p>
          <a href="https://carehires.com/" className={styles.learnMore}>
            Learn More
            <img src={Arrow} alt="arrow" className={styles.arrowIcon} />
          </a>
        </Card>
      ),
    },
    {
      appId: Apps.ROTA,
      myAppComponent: (
        <Card className={styles.appCard} style={{ width: '500px', marginRight: '10px', minHeight: '190px' }} onClick={() => goToPlatform(import.meta.env.VITE_ROTA_APP_URL as string)}>
          <h4>
            <span className={styles.weight}>Care</span>
            <span style={{ color: "#1D4ED8", fontWeight: 600 }}> Rota</span>
          </h4>
          <div className={styles.poweredByContainer}>
            <span className={styles.poweredBy}>powered by</span>
            <img
              className="login-title"
              src={CareHiresLogo}
              alt="CareHires Logo"
            />
          </div>
          <div className={styles.lineSeparator}></div>
          <div className={styles.contentWrapper}>
            <img src={RotaIcon} alt="Care Rota" />
            <p>
              An all-in-one platform for managing care teams' daily rosters
              and real-time updates.
            </p>
          </div>
        </Card>
      ),
      otherAppComponent: (
        <Card className={styles.interestedCard}>
          <h3 className={styles.cardTitle}>
            <span className={styles.weight}>Care</span>
            <span className={styles.advanceText}> Rota</span>
          </h3>
          <hr />
          <div className={styles.lineSeparator}></div>
          <p className={styles.cardDescription}>
            <img src={RotaGrayIcon} alt="arrow" className={styles.arrowIcon} />
            An all-in-one platform for managing care teams' daily rosters and
            real-time updates.
          </p>
          <a
            onClick={() => goToLink("Care Rota")}
            className={styles.learnMore}
          >
            Learn More
            <img src={Arrow} alt="arrow" className={styles.arrowIcon} />
          </a>
        </Card>
      ),
    },
    {
      appId: Apps.ACADEMY,
      myAppComponent: (
        <Card className={styles.appCard} style={{ width: '500px', marginRight: '10px', minHeight: '190px' }} onClick={() => goToPlatform(import.meta.env.VITE_CARE_ACADEMY_APP_URL as string)}>
          <h4>
            <span className={styles.weight}>Care</span>
            <span style={{ color: "#1D4ED8", fontWeight: 600 }}> Academy</span>
          </h4>
          <div className={styles.poweredByContainer}>
            <span className={styles.poweredBy}>powered by</span>
            <img
              className="login-title"
              src={CareHiresLogo}
              alt="CareHires Logo"
            />
          </div>
          <div className={styles.lineSeparatorThird}></div>
          <div className={styles.contentWrapper}>
            <img src={AcademyIcon} alt="Care Academy" />
            <p>
              Learning management system designed for workers to gain
              certifications and enhance skills
            </p>
          </div>
        </Card>
      ),
      otherAppComponent: (
        <Card className={styles.interestedCard}>
          <h3 className={styles.cardTitle}>
            <span className={styles.capitalText}>Care</span>
            <span className={styles.advanceText}> Academy</span>
          </h3>
          <hr />
          <div className={styles.lineSeparator}></div>
          <p className={styles.cardDescription}>
            <img src={AcademyGrayIcon} alt="arrow" className={styles.arrowIcon} />
            Learning management system designed for workers to gain
            certifications and enhance skills
          </p>
          <a
            onClick={() => goToLink("Care Academy")}
            className={styles.learnMore}
          >
            Learn More
            <img src={Arrow} alt="arrow" className={styles.arrowIcon} />
          </a>
        </Card>
      ),
    },
    {
      appId: Apps.CAPITAL_ADVANCE,
      myAppComponent: (
        <Card className={styles.appCard} style={{ width: '500px', marginRight: '10px', minHeight: '190px' }}>
          <h4>
            Capital
            <span style={{ color: "#1D4ED8", fontWeight: 600 }}> Advance</span>
          </h4>
          <div className={styles.poweredByContainer}>
            <span className={styles.poweredBy}>powered by</span>
            <img
              className="login-title"
              src={CareHiresLogo}
              alt="CareHires Logo"
            />
          </div>
          <div className={styles.lineSeparatorThird}></div>
          <div className={styles.contentWrapper}>
            <img src={CaIcon} alt="Care Academy" />
            <p>
              Receive immediate access to outstanding invoice funds,
              eliminating payment delays.
            </p>
          </div>
        </Card>
      ),
      otherAppComponent: (
        <Card className={styles.interestedCard}>
          <h3 className={styles.cardTitle}>
            <span className={styles.capitalText}>Capital</span>
            <span className={styles.advanceText}> Advance</span>
          </h3>
          <div className={styles.poweredByContainerCapital}>
            <span className={styles.poweredBy}>powered by</span>
            <img
              className="login-title"
              src={CareHiresLogo}
              alt="CareHires Logo"
            />
          </div>
          <hr style={{ margin: 0 }} />
          <div className={styles.lineSeparator}></div>
          <p className={styles.cardDescription}>
            <img src={CaGrayIcon} alt="arrow" className={styles.arrowIcon} />
            Receive immediate access to outstanding invoice funds, eliminating
            payment delays.
          </p>
          <a
            onClick={() => goToLink("Capital Advance")}
            className={styles.learnMore}
          >
            Learn More
            <img src={Arrow} alt="arrow" className={styles.arrowIcon} />
          </a>
        </Card>
      ),
    },
    {
      appId: Apps.B4C,
      myAppComponent: (
        <Card className={styles.appCard} style={{ width: '500px', marginRight: '10px', minHeight: '190px' }} onClick={() => goToPlatform(import.meta.env.VITE_B4C_APP_URL as string)}>
          <img
            className="login-title"
            src={CareHiresLogo}
            alt="CareHires Logo"
          />
          <h4>
          <span style={{ color: "#1D4ED8", fontWeight: 600 }}>Marketplace</span> 
          </h4>
          <div className={styles.lineSeparatorThird}></div>
          <div className={styles.contentWrapper}>
            <img src={B4cIcon} alt="Care Academy" />
            <p>
              A platform for automated bidding, allowing workers & agencies to
              negotiate and secure jobs.
            </p>
          </div>
        </Card>
      ),
      otherAppComponent: (
        <Card className={styles.interestedCard}>
          <h3 className={styles.cardTitle}>
            <span className={styles.bidText}>Care Hires</span>
            <span className={styles.careText}> Marketplace</span>
          </h3>
          <hr />
          <p className={styles.cardDescription}>
            <img src={B4cGrayIcon} alt="arrow" className={styles.arrowIcon} />A
            platform for automated bidding, allowing workers & agencies to
            negotiate and secure jobs.
          </p>
          <a
            onClick={() => goToLink("Bid4Care")}
            className={styles.learnMore}
          >
            Learn More
            <img src={Arrow} alt="arrow" className={styles.arrowIcon} />
          </a>
        </Card>
      ),
    },
  ];

  const goToLink = (platform: string) => {
    window.location.href = `try-now-landing-page/${platform}`;
  };

  const goToPlatform = (platform: string) => {
    window.open(platform, "_blank");
  };  

  useEffect(() => {
    const myAssignedApps: any[] = [];
    const otherAvailableApps: any[] = [];
    let apps: any[] = [];

    if(import.meta.env.VITE_ENABLE_CAPITAL_ADVANCE == "false" || !import.meta.env.VITE_ENABLE_CAPITAL_ADVANCE){
      apps = appComponents.filter((app)=>app.appId !== Apps.CAPITAL_ADVANCE)
    } else {
      apps = appComponents
    }

    const assignAppsToComponents = (userApps: string[]) => {
      apps.forEach(({ appId, myAppComponent, otherAppComponent }) => {
        if (userApps?.includes(appId)) {
          myAssignedApps.push(myAppComponent);
        }  else {
          otherAvailableApps.push(otherAppComponent);
        }
      });

      setMyApps(myAssignedApps);
      setOtherApps(otherAvailableApps);
    };

    const fetchAndAssignApps = async () => {
      if (userData?.provider || userData?.agency) {
        const orgType = userData.provider ? "provider" : "agency";
        const orgId = userData.provider?._id || userData.agency?._id;

        const response = await getUserCompaniesByUID(userData._id, orgType, orgId, accessToken);
        const companies = response.data;

        const uniqueApps = Array.from(new Set(companies.flatMap((company: any) => company.apps)))
          .map((app: any) => app.appId.appId);

        setUserApps(uniqueApps);
        assignAppsToComponents(uniqueApps);
      } else {
        const userApps = userData?.apps?.map((app: any) => app.appId.appId);
        setUserApps(userApps);
        assignAppsToComponents(userApps);
      }
    };

    fetchAndAssignApps();
    setTimeout(() => checkOverflow(), 1000);;
  }, []);

  const sampleBlogArticles: any[] = [
    {
      image:
        "https://carehires.com/wp-content/uploads/2023/11/Blog-on-Benefits-of-a-rostering-platform-for-your-Care-HomeArtboard-1-1-1024x1024.webp",
      text: "7 Reasons Why a Rostering Platform is a Must-Need for Your Care Organisation",
      link: "https://carehires.com/blogs/7-reasons-why-a-rostering-platform-is-a-must-need-for-your-care-organisation",
      date: "November 2023",
      readTime: "6 min read",
    },
    {
      image:
        "https://carehires.com/wp-content/uploads/2024/01/Blog-on-AI-and-whats-new-in-social-careArtboard-1-1024x1024.webp",
      text: "From Avatars to Robots, What's New in Social Care and the Move to Digitalisation?",
      link: "https://carehires.com/blogs/from-avatars-to-robots-whats-new-in-social-care-and-the-move-to-digitalisation",
      date: "October 2023",
      readTime: "6 min read",
    },
  ];
  const whitePapers: any[] = [
    {
      image:
        "https://carehires.com/wp-content/uploads/2024/07/LinkedIn-ad-1200-x-1200-px-2-1024x1024.png",
      text: "The Goldilocks Theory: Staffing Ratios across adult social care",
      link: "https://carehires.com/white-papers/staffing-ratios-in-adult-social-care-report/",
    },
    {
      image:
        "https://carehires.com/wp-content/uploads/2024/02/Digital-Skills-Framework-WPArtboard-1-jpg.webp",
      text: "How to Create A Digitally Savvy Care Staff?",
      link: "https://carehires.com/white-papers/how-to-create-a-digitally-savvy-care-staff/",
    },
  ];
  const fetchBlogs = async () => {
    try {
      const response = await fetch("https://carehires.com/blogs");
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const blogArticles = [...(doc.querySelectorAll(".elementor-post") as any)]
        .slice(0, 2)
        .map((blog) => {
          const titleElement = blog.querySelector(".elementor-post__title a");
          const linkElement = blog.querySelector(
            ".elementor-post__thumbnail__link"
          );
          const imageElement = blog.querySelector(
            ".elementor-post__thumbnail img"
          );
          const dateElement = blog.querySelector(
            ".elementor-post__meta-data .elementor-post-date"
          );

          return {
            title: titleElement ? titleElement.innerText.trim() : "No title",
            url: linkElement ? linkElement.href : "#",
            image: imageElement ? imageElement.src : "",
            date: dateElement ? dateElement.innerText.trim() : "No date",
          };
        });
      if (blogArticles.length > 0) {
        setChBlogData(blogArticles);
      } else {
        setChBlogData(sampleBlogArticles);
      }
      return blogArticles;
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  const checkIsDefaultCompany = () => {
    const currentCompany = userCompanies?.find((company: any) => company.isSelected);
    return currentCompany?.isDefault;
  }

  useEffect(() => {
    const fetchUserImages = async () => {
      if (userData?.provider?.parentCompany || userData?.agency?.parentCompany) {
        const type = "parent-company";
        const ids = [userData?.provider?.parentCompany?._id || userData?.agency?.parentCompany?._id];

        try {
          const res = await getUserImages(type, ids, accessToken);
          if (res.data.length > 0) {

            if (userData.userGroup === 'Provider') {
              setCurrentUser({
                ...userData,
                provider: {
                  ...userData.provider,
                  parentCompany: {
                    ...userData.provider.parentCompany,
                    image: res.data[0].image
                  }
                }
              })
            } else {
              setCurrentUser({
                ...userData,
                agency: {
                  ...userData.agency,
                  parentCompany: {
                    ...userData.agency.parentCompany,
                    image: res.data[0].image
                  }
                }
              })
            }
          }
        } catch (error) {
          console.error('Error fetching user images:', error);
        }
      }
    };

    fetchUserImages();
  }, []);

  useEffect(() => {
    const getNotices = async () => {
      const response = await getCurrentNotice(accessToken);
      setNoticeData(response.data);
    };
    getNotices();
    fetchBlogs();
  }, []);

  return (
    <>
      <div className="row mt-2 mb-2" style={{ width: "100%" }}>
        <div className="col-md-6 d-flex ali">
          <div style={{ textAlign: "left", marginLeft: '10px' }}>
            <h2
              style={{
                fontSize: "36px",
                fontWeight: "400",
                color: "#14154f",
              }}
            >
              Welcome back,
              <span className="ms-2" style={{ color: "#14154f", fontWeight: "650" }}>
                {currentUser?.fullName}
              </span>
            </h2>
            <p
              style={{
                fontSize: "18px",
                fontWeight: "400",
                color: "#14154f",
                margin: "0 auto",
              }}
            >
              "Magic is believing in yourself. If you can make that happen, you can
              make anything happen."
            </p>
          </div>
        </div>
        <div className="col-md-6" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
          {(currentUser?.provider?.parentCompany || currentUser?.agency?.parentCompany) && (
            <div style={{
              width: "fit-content",
              padding: "10px",
              borderRadius: "10px",
              display: "flex",
              backgroundColor: "#fff",
            }}>
              <img
                className="me-4"
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "100%",
                }}
                src={
                  currentUser?.provider?.parentCompany?.image?.imageSmall ||
                  currentUser?.agency?.parentCompany?.image?.imageSmall ||
                  DefaultCompanyLogo
                }
                alt="Parent Company Logo"
              />
              <div style={{ marginRight: !checkIsDefaultCompany() ? '40px' : '0px' }}>
                <p className=" mb-1" style={{ fontSize: "24px", fontWeight: "500" }}>
                  {currentUser?.provider?.parentCompany?.name ||
                    currentUser?.agency?.parentCompany?.name}
                </p>
                <p className="text-sm font-normal mb-0.5">
                  Currently logged in to{" "}
                  <b>
                    {currentUser?.provider?.companyName ||
                      currentUser?.agency?.businessName}
                  </b>
                </p>
              </div>
              {checkIsDefaultCompany() && (
                <span className={styles.defaultTag}>
                  Default
                </span>
              )}
            </div>
          )}
        </div>
      </div>
      <div className={styles["scrollable-container"]}>
        <Card>
          <div className="row d-flex align-items-center">
            <div className="col">
              <h3 style={{ marginTop: "0" }} className={styles.sectionTitle}>
                My Apps
              </h3>
            </div>
            {isOverflowing && (
              <div className="col d-flex justify-content-end">
                <img
                  style={{ cursor: "pointer" }}
                  src={LeftArrow}
                  alt="Left Arrow"
                  onClick={() => scroll("left", myAppsRef)}
                />
                <img
                  style={{ cursor: "pointer" }}
                  src={RightArrow}
                  alt="Right Arrow"
                  onClick={() => scroll("right", myAppsRef)}
                />
              </div>
            )}
          </div>

          <div
            ref={myAppsRef}
            style={{
              width: "100%",
              overflowX: "hidden",
              scrollBehavior: "smooth",
            }}
          >
            <div className="d-flex" style={{ gap: "10px", width: "max-content" }}>
              {myApps}
              <Card
                className={`${styles.appCard} ${styles.whiteBackgroundCard}`}
                style={{ width: "500px", minHeight: "190px" }}
                onClick={() =>
                  goToPlatform(import.meta.env.VITE_KNOWLEDGE_BASE_URL as string)
                }
              >
                <h4>Knowledge Base</h4>
                <div className={styles.lineSeparatorSecond}></div>
                <div className={styles.contentWrapper}>
                  <img src={KbIcon} alt="Knowledge Base" />
                  <p style={{ color: "#6B7280" }}>
                    Resources to easily access essential information, guides and
                    other materials.
                  </p>
                </div>
              </Card>
            </div>
          </div>
        </Card>
        {otherApps.length > 0 && (
          <Card className="mt-4" >
            <div className="row d-flex align-items-center">
              <div className="col"><h3 style={{ marginTop: "0" }} className={styles.sectionTitle}>
                You might be interested in
              </h3></div>
              {isOtherOverflowing && (
                <div className="col d-flex justify-content-end"><img style={{ cursor: "pointer" }} src={LeftArrow} alt="Left Arrow" onClick={() => scroll("left", otherAppsRef)} />
                  <img style={{ cursor: "pointer" }} src={RightArrow} alt="Right Arrow" onClick={() => scroll("right", otherAppsRef)} /></div>
              )}
            </div>
            <div ref={otherAppsRef} style={{ width: '100%', overflowX: 'hidden', scrollBehavior: "smooth" }}>
              <div className="d-flex" style={{ gap: "10px", }}>
                {otherApps}
              </div>
            </div>
          </Card>
        )}


        <Row className="mt-3" style={{ display: "flex", justifyContent: "space-between" }}>
          <Col span={11}>
            <section className={styles.recentArticlesSection}>
              <h2 className={styles.sectionTitle}>Recent Articles</h2>

              <Row gutter={[16, 16]}>
                {chBlogData.map((article: any, index: number) => (
                  <Col key={index} xs={24} sm={24} md={12}>
                    <div
                      className={styles.imageCard}
                      style={{ backgroundImage: `url(${article.image})` }}
                    ></div>
                    <h3 style={{ marginTop: '10px' }} className={styles.blockText}>{article.title}</h3>
                    <a href={article.url} className={styles.readMore}>
                      Read Article
                      <ArrowRightOutlined
                        rotate={-50}
                        style={{ fontSize: "small" }}
                      />
                    </a>
                  </Col>
                ))}
              </Row>
            </section>
          </Col>
          <Col span={11}>
            <section className={styles.recentArticlesSection}>
              <h2 className={styles.sectionTitle}>Whitepapers</h2>

              <Row gutter={[16, 16]}>
                {whitePapers.map((article: any, index: number) => (
                  <Col key={index} xs={24} sm={24} md={12}>
                    <div
                      className={styles.imageCard}
                      style={{ backgroundImage: `url(${article.image})` }}
                    ></div>
                    <h3 style={{ marginTop: '10px' }} className={styles.blockText}>{article.text}</h3>
                    <a href={article.link} className={styles.readMore}>
                      Read Article
                      <ArrowRightOutlined
                        rotate={-50}
                        style={{ fontSize: "small" }}
                      />
                    </a>
                  </Col>
                ))}
              </Row>
            </section>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Overview;